import { FlexRowSmallSpacedCentered } from '@fox/layout/src/flex';
import MUIAlert from '@mui/material/Alert';
import MuiSnackbar, { SnackbarProps as MuiSnackbarProps } from '@mui/material/Snackbar';
import MuiSnackbarContent, { SnackbarContentProps as MuiSnackbarContentProps } from '@mui/material/SnackbarContent';
import { forwardRef } from 'react';
import ReactDOM from 'react-dom';

export interface ISnackbarProps extends MuiSnackbarProps {
	severity?: 'success' | 'info' | 'warning' | 'error';
}

export type SnackbarState = Pick<ISnackbarProps, 'open' | 'message' | 'severity' | 'autoHideDuration' | 'anchorOrigin'>;

export const MuiAlertSnackbar = (props: ISnackbarProps) => {
	return ReactDOM.createPortal(
		<Snackbar
			anchorOrigin={props.anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
			autoHideDuration={props.autoHideDuration || 3000}
			onClose={props.onClose}
			{...props}
		>
			<MUIAlert sx={{ width: '100%', alignItems: 'center' }} severity={props.severity ?? 'info'}>
				<FlexRowSmallSpacedCentered>
					{props.message}
					{props.action}
				</FlexRowSmallSpacedCentered>
			</MUIAlert>
		</Snackbar>,
		document.body
	);
};

export interface SnackbarProps extends MuiSnackbarProps {}

export const Snackbar = forwardRef((props: SnackbarProps, ref: React.Ref<unknown>) => {
	return <MuiSnackbar ref={ref} {...props} />;
});

export interface SnackbarContentProps extends MuiSnackbarContentProps {}

export const SnackbarContent = forwardRef((props: SnackbarContentProps, ref: React.Ref<HTMLDivElement>) => {
	return <MuiSnackbarContent ref={ref} {...props} />;
});
